import { lazy } from 'react';
import {
  adaptiveWrapperOptions,
  ModalWrapper,
} from '../../appComponents/ModalWrapper';
import { useIsMobileLayout } from '../../components/styles/responsive';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { TutorialsPageProps } from './TutorialsPageContent';

const TutorialsPageContent = lazy(() => import('./TutorialsPageContent'));

const TutorialsPage = wrapLazyNavigatorScreen((props: TutorialsPageProps) => {
  const isMobile = useIsMobileLayout();
  if (isMobile) {
    return <TutorialsPageContent {...props} />;
  }
  return (
    <ModalWrapper dismissible={true}>
      <TutorialsPageContent {...props} />
    </ModalWrapper>
  );
}, adaptiveWrapperOptions());

export default TutorialsPage;
